export const NAME = 'dialogs';
